import React, { Component } from 'react'

import Cookie from '../../../utils/Cookie'
import Adresse from './Adresse.jsx'
import Bygg from './Bygg.jsx'
import Eier from './Eier.jsx'
import Eiendom from './Eiendom.jsx'
import Stedsnavn from './Stedsnavn.jsx'
import AdresseDetails from '../AdresseDetails/AdresseDetails.jsx'
import ByggDetails from '../ByggDetails/ByggDetails.jsx'
import MatrikkelenhetDetails from '../MatrikkelenhetDetails/MatrikkelenhetDetails.jsx'
import EierDetails from '../EierDetails/EierDetails.jsx'
import MatrikkelSearchEvents from '../MatrikkelSearchEvents.js'

class ResultList extends Component {
    state =  {
        selectedDomainKlasse: null,
        selectedMatrikkelBubbleId: null
    }

    onSelectResult = (result) => {
        this.addResultToSearchHistory(result)

        var domainKlasse = "Adresse"
        var matrikkelBubbleId = result.adresseid
        if (result.kilde == "Bygg") {
            domainKlasse = "Bygg"
            matrikkelBubbleId = result.byggid
        }
        if (result.kilde == "Eier") {
            domainKlasse = "Eier"
            matrikkelBubbleId = result.personid
        }
        if (result.kilde == "Matrikkelenhet") {
            domainKlasse = "Matrikkelenhet"
            matrikkelBubbleId = result.matrikkelenhetid
        }
        if (result.kilde == "Stedsnavn") {
            domainKlasse = null
            matrikkelBubbleId = null

            this.props.onEvent({
                type: MatrikkelSearchEvents.ShowObject,
                data: {
                    type: MatrikkelSearchEvents.ShowStedsnavn,
                    stedsnavn: result
                }
            })
        }

        this.setState({selectedDomainKlasse: domainKlasse, selectedMatrikkelBubbleId: matrikkelBubbleId})
        this.props.onResultSelected(domainKlasse, matrikkelBubbleId)
    }

    addResultToSearchHistory = result => {
        var searchHistory = Cookie.getProperty("searchHistory")
        if (searchHistory == null) searchHistory = []

        var resultExists = false;
        searchHistory.map(h => {
            if (result.kilde != h.kilde || resultExists) return

            if (result.kilde == "Adresse" && result.adresseid != h.adresseid) return
            if (result.kilde == "Bygg" && result.byggid != h.byggid) return
            if (result.kilde == "Matrikkelenhet" && result.matrikkelenhetid != h.matrikkelenhetid) return
            if (result.kilde == "Eier" && result.eierid != h.eierid) return
            if (result.kilde == "Stedsnavn" && result.stedsnavn != h.stedsnavn) return

            resultExists = true
        })

        if (resultExists) return;

        searchHistory.unshift(result)
        searchHistory = searchHistory.slice(0, 5)
        Cookie.setProperty("searchHistory", searchHistory);
    }

    UNSAFE_componentWillMount = () => {
        if (this.props.domainKlasse != null && this.props.matrikkelBubbleId != null) {
            this.setState({selectedDomainKlasse: this.props.domainKlasse, selectedMatrikkelBubbleId: this.props.matrikkelBubbleId})
        }
    }

    UNSAFE_componentWillReceiveProps = (nextProps) => {
        if (nextProps.domainKlasse != null && nextProps.matrikkelBubbleId != null) {
            this.setState({selectedDomainKlasse: nextProps.domainKlasse, selectedMatrikkelBubbleId: nextProps.matrikkelBubbleId})
        }
        else {
            this.setState({selectedDomainKlasse: null, selectedMatrikkelBubbleId: null})
        }
    }

    handleMatrikkelObjectSelected = (event) => {
        if (event.domainKlasse == "Adresse") {
            this.setState({selectedDomainKlasse: event.domainKlasse, selectedMatrikkelBubbleId: event.adresse.adresseId})
        }

        if (event.domainKlasse == "Bygg") {
            this.setState({selectedDomainKlasse: event.domainKlasse, selectedMatrikkelBubbleId: event.bygg.byggId})
        }

        if (event.domainKlasse == "Eier") {
            this.setState({selectedDomainKlasse: event.domainKlasse, selectedMatrikkelBubbleId: event.eier.eierId})
        }

        if (event.domainKlasse == "Matrikkelenhet") {
            this.setState({selectedDomainKlasse: event.domainKlasse, selectedMatrikkelBubbleId: event.matrikkelenhet.matrikkelenhetId})
        }
    }

    render() {
        if (this.state.selectedDomainKlasse == "Adresse" && this.state.selectedMatrikkelBubbleId)
            return (
                <AdresseDetails adresseId={this.state.selectedMatrikkelBubbleId} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.handleMatrikkelObjectSelected} />
            )

        if (this.state.selectedDomainKlasse == "Bygg" && this.state.selectedMatrikkelBubbleId)
            return (
                <ByggDetails byggId={this.state.selectedMatrikkelBubbleId} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.handleMatrikkelObjectSelected} />
            )

        if (this.state.selectedDomainKlasse == "Matrikkelenhet" && this.state.selectedMatrikkelBubbleId)
            return (
                <MatrikkelenhetDetails matrikkelenhetId={this.state.selectedMatrikkelBubbleId} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.handleMatrikkelObjectSelected} />
            )

        if (this.state.selectedDomainKlasse == "Eier" && this.state.selectedMatrikkelBubbleId)
            return (
                <EierDetails eierId={this.state.selectedMatrikkelBubbleId} token={this.props.token} settings={this.props.settings} onEvent={this.props.onEvent} onMatrikkelObjectSelected={this.handleMatrikkelObjectSelected} />
            )

        var stedsnavnId = 0
        return (
            <ul className="resultlist">
                {this.props.results.map((r) => {
                    if (r.kilde == 'Adresse') return (<Adresse key={r.adresseid} adresse={r} onSelectResult={this.onSelectResult}  />)
                    if (r.kilde == 'Bygg') return (<Bygg key={r.byggid} bygg={r} onSelectResult={this.onSelectResult}  />)
                    if (r.kilde == 'Eier') return (<Eier key={r.personid} eier={r} onSelectResult={this.onSelectResult}  />)
                    if (r.kilde == 'Matrikkelenhet') return (<Eiendom key={r.matrikkelenhetid} eiendom={r} onSelectResult={this.onSelectResult}  />)
                    if (r.kilde == 'Stedsnavn') return (<Stedsnavn key={stedsnavnId++} stedsnavn={r} onSelectResult={this.onSelectResult}  />)
                    })}
            </ul>
        )
    }
}

export default ResultList